import { gql } from "@apollo/client";

export const DETECT_SLOTS = gql`
  mutation DetectSlots($screenVersion: ScreenVersionDataInput!) {
    detectSlots(screenVersion: $screenVersion) {
      id
      versionNumber
      htmlContent
      bindingManifest {
        id
        slots
        report
      }
    }
  }
`;

export const PUBLISH_SCREEN_VERSION = gql`
  mutation PublishScreenVersion($where: ScreenVersionWhereInput) {
    publishScreenVersion(where: $where) {
      id
      versionNumber
      status
      publishedAt
      publishedBy
    }
  }
`;

export const UPDATE_BINDING_MANIFEST = gql`
  mutation UpdateBindingManifest(
    $where: BindingManifestWhereInput
    $data: BindingManifestDataInput
  ) {
    updateBindingManifest(where: $where, data: $data) {
      id
      slots
    }
  }
`;

export const UPDATE_TRANSLATION_TABLE = gql`
  mutation UpdateTranslationTable(
    $where: TranslationTableWhereInput
    $data: TranslationTableDataInput
  ) {
    updateTranslationTable(where: $where, data: $data) {
      id
      entries
    }
  }
`;

export const ADD_SCREEN = gql`
  mutation AddScreen($data: ScreenDataInput) {
    addScreen(data: $data) {
      id
    }
  }
`;

export const ADD_SCREEN_VERSION = gql`
  mutation AddScreenVersion($data: ScreenVersionDataInput) {
    addScreenVersion(data: $data) {
      id
      versionNumber
      status
      htmlContent
      styleContent
    }
  }
`;

export const UPDATE_SCREEN = gql`
  mutation UpdateScreen($where: ScreenWhereInput, $data: ScreenDataInput) {
    updateScreen(where: $where, data: $data) {
      id
    }
  }
`;

export const DELETE_SCREEN = gql`
  mutation DeleteScreen($where: ScreenWhereInput) {
    deleteScreen(where: $where) {
      id
    }
  }
`;

export const IMPORT_UI_PROVIDER_SCREENS = gql`
  mutation ImportUiProviderScreens(
    $provider: UiProviderDataInput!
    $mappings: [UiProviderScreenMappingInput!]!
  ) {
    importUiProviderScreens(provider: $provider, mappings: $mappings) {
      status {
        id
        name
        tag
      }
      screen {
        id
        status {
          id
          name
        }
      }
      error
    }
  }
`;

export const ADD_SCREEN_STATE = gql`
  mutation AddScreenState($data: ScreenStateDataInput) {
    addScreenState(data: $data) {
      id
      name
      order
      htmlContent
      conditions
      bindingManifest {
        id
        slots
      }
    }
  }
`;

export const UPDATE_SCREEN_STATE = gql`
  mutation UpdateScreenState(
    $where: ScreenStateWhereInput
    $data: ScreenStateDataInput
  ) {
    updateScreenState(where: $where, data: $data) {
      id
      name
      order
      htmlContent
      conditions
      bindingManifest {
        id
        slots
      }
    }
  }
`;

export const DELETE_SCREEN_STATE = gql`
  mutation DeleteScreenState($where: ScreenStateWhereInput) {
    deleteScreenState(where: $where) {
      id
    }
  }
`;

export const DETECT_SLOTS_FOR_STATE = gql`
  mutation DetectSlotsForState($screenState: ScreenStateDataInput!) {
    detectSlotsForState(screenState: $screenState) {
      id
      htmlContent
      bindingManifest {
        id
        slots
      }
    }
  }
`;

export const START_SCREEN_STATE_FROM_IMAGE = gql`
  mutation StartScreenStateFromImage(
    $screenVersion: ScreenVersionWhereInput
    $image: ScreenImageInput!
    $conditionField: String
    $conditionValue: String
    $instructions: String
    $styleContent: String
    $htmlContent: String
  ) {
    startScreenStateFromImage(
      screenVersion: $screenVersion
      image: $image
      conditionField: $conditionField
      conditionValue: $conditionValue
      instructions: $instructions
      styleContent: $styleContent
      htmlContent: $htmlContent
    ) {
      id
      status
    }
  }
`;

export const UPDATE_SCREEN_VERSION = gql`
  mutation UpdateScreenVersion(
    $where: ScreenVersionWhereInput
    $data: ScreenVersionDataInput
  ) {
    updateScreenVersion(where: $where, data: $data) {
      id
      htmlContent
      styleContent
    }
  }
`;
export const START_SCREEN_REVISION = gql`
  mutation StartScreenRevision(
    $screenVersion: ScreenVersionWhereInput!
    $screenState: ScreenStateWhereInput
    $instructions: String!
  ) {
    startScreenRevision(
      screenVersion: $screenVersion
      screenState: $screenState
      instructions: $instructions
    ) {
      id
      status
    }
  }
`;

export const START_SCREEN_HTML_FROM_IMAGE = gql`
  mutation StartScreenHtmlFromImage(
    $image: ScreenImageInput!
    $instructions: String
  ) {
    startScreenHtmlFromImage(image: $image, instructions: $instructions) {
      id
      status
    }
  }
`;

const screens = {
  DETECT_SLOTS,
  PUBLISH_SCREEN_VERSION,
  UPDATE_BINDING_MANIFEST,
  UPDATE_TRANSLATION_TABLE,
  ADD_SCREEN,
  ADD_SCREEN_VERSION,
  UPDATE_SCREEN,
  DELETE_SCREEN,
  IMPORT_UI_PROVIDER_SCREENS,
  ADD_SCREEN_STATE,
  UPDATE_SCREEN_STATE,
  DELETE_SCREEN_STATE,
  DETECT_SLOTS_FOR_STATE,
  START_SCREEN_HTML_FROM_IMAGE,
  START_SCREEN_STATE_FROM_IMAGE,
  START_SCREEN_REVISION,
  UPDATE_SCREEN_VERSION,
};

export default screens;
